import { Button, IconLocation16 } from '@cian/ui-kit';
import * as React from 'react';

interface ILocationPickerButtonProps {
  children: string;
  onClick(): void;
}

export const LocationPickerButton: React.FC<ILocationPickerButtonProps> = ({ children, onClick }) => {
  return (
    <Button onClick={onClick} size="XS" theme="stroke_secondary" beforeIcon={<IconLocation16 />}>
      {children}
    </Button>
  );
};
